<template>
  <code-mirror
    :value="getValue"
    :readOnly="readOnly"
    @change="handleValueChange"
    @save="save"
  ></code-mirror>
</template>

<script>
import CodeMirror from "./CodeMirror.vue";
import parser from "@/utils/parser";
import { $isString } from "@/utils/helper";

export default {
  name: "CodeMirrorEditor",
  components: { CodeMirror },
  /* eslint-disable vue/require-prop-types */
  /*props: ['value'],*/
  props: {
    value: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getValue() {
      let result = this.value;

      if ($isString(this.value)) {
        try {
          result = parser.parse(this.value);
        } catch (e) {
          return this.value;
        }
      }

      return parser.stringify(result, null, 2);
    }
  },
  methods: {
    handleValueChange(v) {
      this.$emit("input", v);
    },
    save(val) {
      this.$emit("save", val);
    }
  }
};
</script>

<style>

</style>
